import React, { useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import {
  LinkWithGAPromoClick,
  Section,
  SectionSubTitle,
  Swiper,
  SwiperSlide,
  Typography,
} from 'common/components';
import { usePromoViewEvent } from 'common/hooks';
import { createElementKey } from 'utils/create-element-key';
import { ADVICE_SECTION_DATA } from './advice-section-constants';
import { AdviceImage, adviceItemStyle, subTitleStyle, swiperStyle } from './advice-section-styles';
import { AdviceSectionDataStructure } from './advice-section-types';

/**
 * Вью секции с советами
 */
export const AdviceSection = () => {
  const refs = useRef<HTMLAnchorElement[]>([]);
  const { t } = useTranslation();

  const promotions = useMemo(
    () =>
      ADVICE_SECTION_DATA.map((advice: AdviceSectionDataStructure, index: number) => ({
        name: 'vannuyuKomnatu_bottom',
        creative: t(advice.title),
        position: (index + 1).toString(),
      })),
    [t]
  );

  usePromoViewEvent(refs, 'landingVannuyuKomnatu / articles', promotions);

  return (
    <Section>
      <SectionSubTitle className={subTitleStyle} margin="l">
        {t('advice-section.title')}
      </SectionSubTitle>
      <Swiper slidesPerView="auto" watchOverflow className={swiperStyle}>
        {ADVICE_SECTION_DATA.map(({ href, src, title }: AdviceSectionDataStructure, index: number) => (
          <SwiperSlide key={createElementKey('advice', index)} className={adviceItemStyle}>
            <LinkWithGAPromoClick
              bannerRefs={refs}
              elementBlock="landingVannuyuKomnatu / articles"
              position={index}
              promotion={promotions[index]}
              href={href}
              title={t(title)}>
              <AdviceImage src={src} alt={t(title) || ''} loading="lazy" />
              <Typography size="subtitle" variant="l">
                {t(title)}
              </Typography>
            </LinkWithGAPromoClick>
          </SwiperSlide>
        ))}
      </Swiper>
    </Section>
  );
};
